import * as Yup from "yup";
import { regexList } from "../../Constants";

export const LoginContents = {
  titles: {
    heading: "Log In"
  },
  fields: {
    gstin: "gstin"
  },
  placeholders: {
    gstin: "Select GSTIN of the company",
    phoneNumber: "Enter Phone number"
  },
  labels: {
    gstin: "GSTIN of the company",
    phoneNumber: "Enter mobile number used for Registration",
    loading: "Loading",
    verified: "Verified",
    otpSuccess: "OTP has been successfully sent",
    login: "Log In",
    reportIssue: "Report Issue?",
    registrationPrefix: "New to Jitfin? ",
    register: "Register"
  },
  feedbacks: {
    phoneNumberNotVerified: "Phone number not verified",
    loginNoAccess: "No Access to login page when loggedin"
  }
};

const errors = {
  required: "Required",
  invalidPhoneNumber: "Enter a valid Phone number"
};

export const LoginValidationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .matches(regexList.phoneNumber, errors.invalidPhoneNumber)
    .required(errors.required),
  gstin: Yup.string().required(errors.required)
});
